import Listing from "@components/Listing"

const TelegramApp = () => {
  return <Listing />
}

export default TelegramApp
